import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { KTIcon } from '../../../../../../../_metronic/helpers';
import { useNavigate } from 'react-router-dom';

interface SaleOrder {
    saleOrderId?: string | number;
    price?: string | number;
    quantity?: string | number;
    remainQuantity?: string | number;
    pickupPointName?: string;
    companyName?: string;
}

interface ConfirmedOrderItem {
    price?: string | number;
}

interface ConfirmedOrderDetail {
    items?: ConfirmedOrderItem[];
}

interface User {
    assignedSaleOrders?: SaleOrder[];
    confirmedOrderDetails?: ConfirmedOrderDetail[];
    [key: string]: any;
}

interface UserTableModalProps {
    user: User;
    onClose: () => void;
    show: boolean;
}

export const OrderMngAssigned: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const navigate = useNavigate();
    const saleOrders = user?.assignedSaleOrders || [];
    const salePrice = user?.confirmedOrderDetails?.[0]?.items?.[0]?.price;

    const totalQuantity = saleOrders.reduce((acc, curr) => {
        const qty = parseFloat(String(curr?.quantity || 0));
        return acc + (isNaN(qty) ? 0 : qty);
    }, 0);

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            onHide={onClose}
            centered
            size='lg'
        >
            <div className='modal-content rounded-3 shadow-sm'>
                {/* Header */}
                <div className='modal-header py-4 px-6 border-0 bg-light rounded-top d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center gap-3'>
                        <div className='symbol symbol-40px symbol-circle bg-light-primary d-flex align-items-center justify-content-center'>
                            <KTIcon iconName='basket' className='fs-2 text-primary' />
                        </div>
                        <div>
                            <h3 className='fw-bolder modal-title text-gray-900 mb-0 fs-4'>Assigned Sale Orders</h3>
                            <span className='text-muted fs-7 fw-semibold'>View item details and supply management</span>
                        </div>
                    </div>
                    <button
                        type='button'
                        className='btn btn-icon btn-sm btn-active-light-primary rounded-circle'
                        onClick={onClose}
                        aria-label='Close'
                    >
                        <KTIcon iconName='cross' className='fs-2' />
                    </button>
                </div>

                {/* Modal Body */}
                <div className='modal-body px-6 py-5'>
                    {/* Quick Summary Cards */}
                    {/* {saleOrders.length > 0 && (
            <div className='row g-3 mb-5'>
              <div className='col-6 col-md-4'>
                <div className='border border-gray-200 border-dashed rounded py-3 px-4 bg-light-subtle'>
                  <div className='fs-8 fw-semibold text-muted text-uppercase'>Total Orders</div>
                  <div className='fs-4 fw-bolder text-gray-800'>{saleOrders.length}</div>
                </div>
              </div>
              <div className='col-6 col-md-4'>
                <div className='border border-gray-200 border-dashed rounded py-3 px-4 bg-light-subtle'>
                  <div className='fs-8 fw-semibold text-muted text-uppercase'>Total Quantity</div>
                  <div className='fs-4 fw-bolder text-primary'>{totalQuantity > 0 ? `${totalQuantity} Kg` : 'N/A'}</div>
                </div>
              </div>
              {salePrice && (
                <div className='col-12 col-md-4'>
                  <div className='border border-gray-200 border-dashed rounded py-3 px-4 bg-light-subtle'>
                    <div className='fs-8 fw-semibold text-muted text-uppercase'>Default Sale Price</div>
                    <div className='fs-4 fw-bolder text-success'>₹{salePrice} / Kg</div>
                  </div>
                </div>
              )}
            </div>
          )} */}

                    {/* Table */}
                    <div className='table-responsive border rounded-3 overflow-hidden'>
                        <table className='table align-middle table-row-dashed fs-6 gy-3 mb-0'>
                            <thead>
                                <tr className='text-start text-gray-700 fw-bolder fs-7 text-uppercase bg-light border-bottom border-gray-200'>
                                    <th className='ps-4 py-3 min-w-100px'>Sale Order ID</th>
                                    <th className='py-3 min-w-100px'>Sale Price</th>
                                    <th className='py-3 min-w-110px'>Purchase Price</th>
                                    <th className='py-3 min-w-80px'>Qty</th>
                                    <th className='py-3 min-w-110px'>To Be Supplied</th>
                                    <th className='py-3 min-w-150px'>Company Name</th>
                                    <th className='pe-4 py-3 text-center min-w-120px'>Generate Order</th>
                                </tr>
                            </thead>
                            <tbody className='text-gray-700 fw-semibold'>
                                {saleOrders.length > 0 ? (
                                    saleOrders.map((order, index) => {
                                        const locationName = order?.pickupPointName
                                            ? order.pickupPointName.replace(', null', '')
                                            : order?.companyName || 'N/A';

                                        return (
                                            <tr key={order?.saleOrderId || index} className='hover-bg-light-subtle'>
                                                <td className='ps-4 py-3'>
                                                    <span className='badge badge-light-primary fw-bolder fs-7 px-3 py-2'>
                                                        {order.saleOrderId || 'N/A'}
                                                    </span>
                                                </td>
                                                <td className='py-3'>
                                                    <span className='fw-bold text-gray-800'>
                                                        {salePrice ? `₹${salePrice} / Kg` : 'N/A'}
                                                    </span>
                                                </td>
                                                <td className='py-3'>
                                                    <span className='fw-bold text-gray-800'>
                                                        {order.price ? `₹${order.price} / Kg` : 'N/A'}
                                                    </span>
                                                </td>
                                                <td className='py-3'>
                                                    <span className='badge badge-light-info fw-bold fs-7 px-2.5 py-1.5'>
                                                        {order.quantity ? `${order.quantity} Kg` : 'N/A'}
                                                    </span>
                                                </td>
                                                <td className='py-3'>
                                                    <span className='badge badge-light-warning fw-bold fs-7 px-2.5 py-1.5'>
                                                        {order.remainQuantity ? `${order.remainQuantity} Kg` : 'N/A'}
                                                    </span>
                                                </td>
                                                <td className='py-3'>
                                                    <div className='d-flex align-items-center gap-1 text-gray-800 fw-semibold text-truncate flex-wrap' style={{ maxWidth: '150px' }} title={locationName}>
                                                        <span className='text-wrap'>{locationName}</span>
                                                    </div>
                                                </td>
                                                <td className='pe-4 py-3 text-center'>
                                                    <button
                                                        type='button'
                                                        className='btn btn-icon btn-sm btn-light-primary btn-active-primary'
                                                        title='Generate Order'
                                                        aria-label='Generate Order'
                                                        onClick={() => navigate(`/apps/sales/order-management/generate-order/${order?.saleOrderId}`, { state: { order, user } })}
                                                    >
                                                        <KTIcon iconName='document' className='fs-3' />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={7} className='text-center py-10'>
                                            <div className='d-flex flex-column align-items-center justify-content-center'>
                                                <KTIcon iconName='document' className='fs-3x text-muted mb-3' />
                                                <span className='text-gray-500 fw-semibold fs-6'>No assigned sale orders found</span>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer */}
                <div className='modal-footer border-0 pt-0 px-6 pb-4 justify-content-end'>
                    <button type='button' className='btn btn-sm btn-secondary fw-bold px-5' onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};